import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import SubTable from './AmenitiesTable'
import AmenitiesEdit from './AmenitiesEdit'
import AmenitiesAdd from './AddAmenity'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'

function Amenities () {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'amenities_manager') ?? {}
  const [showModal, setShowModal] = useState(false)
  const [editShowModal, setEditShowModal] = useState(false)
  const [amenities, setAmenities] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })

  const { searchKey } = filterData
  const allAmenities = async data => {
    try {
      const payload = {
        page,
        pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        keyword: searchKey?.trim()
      }

      const path = apiPath.ListAmenities
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAmenities(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handelEdit = newItem => {
    setItem(newItem)
    setEditShowModal(true)
  }
  const handleChangeData = e => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true })
    setPage(1)
  }
  const handleUserView = newItem => {
    setItem(newItem)
    // setViewShow(true)
  }

  useEffect(() => {
    allAmenities()
  }, [page, sort, filterData])

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              {/* <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <div className='flex'>
                  {(manager?.add ||
                    user?.role === 'admin') && (
                      <button
                        title={t('ADD_AMENITIES')}
                        type='button'
                        className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                        onClick={() => setShowModal(true)}
                      >
                        + {t('ADD_AMENITIES')}
                      </button>
                  )}
                </div>
              </div> */}
              <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
                <label
                  htmlFor='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        {!filterData?.searchKey && (
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        )}
                      </svg>
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      title=''
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('SEARCH_BY_KEYWORD')}
                      value={filterData?.searchKey}
                      required
                      onChange={e => handleChangeData(e)}
                    />
                  </div>
                  {(manager?.add || user?.role === 'admin') && (
                    <button
                      title={t('ADD_AMENITIES')}
                      type='button'
                      className='bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                      onClick={() => setShowModal(true)}
                    >
                      + {t('ADD_AMENITIES')}
                    </button>
                  )}
                </div>
              </div>
            </form>
            <SubTable
              amenities={amenities}
              handelEdit={handelEdit}
              allAmenities={allAmenities}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>

      <>
        {showModal ? (
          <AmenitiesAdd
            setShowModal={setShowModal}
            allAmenities={allAmenities}
          />
        ) : null}
        {editShowModal && (
          <AmenitiesEdit
            setEditShowModal={setEditShowModal}
            allAmenities={allAmenities}
            item={item}
          />
        )}
      </>
    </div>
  )
}

export default Amenities
